"use strict";

angular.module('PatientApp').factory('AuthService', function (PatientUsersService, VueEventTransmitter, VuexStore) {
  var _authService = {
    // Some site areas are restricted to
    // users only. This is our check to make
    // sure this user is available to us
    hasAccess: function hasAccess() {
      // we expect not having a user to return a null
      // but we are going to apply a more broader falsy check
      // than simply on null
      return !!PatientUsersService.getCurrentUser();
    },
    // Try to get user, remember state
    // if we have a user, continue but if
    // we don't, prompt for login the redirect back to state
    requireAuthedUser: function requireAuthedUser(loginOptions) {
      return VuexStore.dispatch('requireAuthedUser', loginOptions);
    },
    // Send logout server request.
    // If we are unable to log the user out,
    // we will clear our cookie for the server
    unauthenticateUser: function unauthenticateUser(showModal) {
      return VuexStore.dispatch('unauthenticateUser', showModal);
    },
    // This is the mechanism which is used to poll
    // or check for a currently authenticated user 
    // as far as what the server knows about.
    fetchAuthenticatedUser: function fetchAuthenticatedUser() {
      return PatientUsersService.fetchUser();
    }
  };
  return _authService;
});